import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Select } from 'antd';
import DataFlowService from '../../../../services/DataFlow.service';
import { PlusOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import ModalFail from '../../../../components/Shared/modal/fail';

const ModalActivity = ({
    open,
    handelClose,
    mode,
    setOpenSuccess,
    activityData,
    getActivityList,
    departmentId,
}) => {
    let { businessProcessId } = useParams();

    const { t, i18n } = useTranslation();
    const [form] = Form.useForm();
    const [nameList, setNameList] = useState([]);
    const [openFail, setOpenFail] = useState(false);
    const [msg, setMsg] = useState('');
    const [disableBtnDelete, setDisableBtnDelete] = useState(false);
    const [departmentList, setDepartmentList] = useState([]);
    const [duplicateData, setDuplicateData] = useState([]);
    const [activityName, setActivityName] = useState({
        value: '',
    });

    useEffect(() => {
        let lang = i18n.language;
        const getDepartmentList = async () => {
            await DataFlowService.getDepartmentList().then((res) => {
                let option = [];
                res?.data?.resultData?.forEach((element) => {
                    option.push({
                        value: lang === 'en' ? element.nameEn : element.nameTh,
                        id: element.departmentId,
                    });
                });
                setDepartmentList([...option]);
            });
        };
        getDepartmentList();
    }, [i18n.language]);

    useEffect(() => {
        if (mode === 'addActivity') {
            form.setFieldsValue({
                departmentId: departmentId,
            });
        } else if (mode === 'editActivity') {
            form.setFieldsValue({
                departmentId: departmentId,
                businessProcessName: activityData.businessProcessName,
                activityName: activityData.activityName,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode, departmentId]);

    const validateAddBtnActivityName = (e) => {
        if (e) {
            return {
                validateStatus: 'error',
                errorMsg: t('dataFlow.PleasePressTheAddbutton'),
            };
        } else {
            return {
                validateStatus: 'success',
                errorMsg: null,
            };
        }
    };

    const validateDuplicateActivityName = (isDuplicate) => {
        if (isDuplicate) {
            return {
                validateStatus: 'error',
                errorMsg: t('dataFlow.ActivityNameIsExist'),
            };
        } else {
            return {
                validateStatus: 'success',
                errorMsg: null,
            };
        }
    };

    const onSubmit = async (e) => {
        setDuplicateData([]);
        e.businessProcessId = businessProcessId;
        if (mode === 'addActivity') {
            if (e.activityName) {
                let value = e.activityName;
                setActivityName({
                    ...validateAddBtnActivityName(value),
                    value,
                });
            } else {
                await DataFlowService.createActivity({ ...e })
                    .then((res) => {
                        if (res.data.resultMsg === 'FAILURE') {
                            setDuplicateData(res.data.errorData.error);
                        } else {
                            clear();
                            setOpenSuccess(true);
                            getActivityList();
                        }
                    })
                    .catch((err) => {
                        setOpenFail(true);
                        setMsg(t('dataFlow.FailedToAddData'));
                    });
            }
        } else {
            //edit mode
            e.activityId = activityData.activityId;
            await DataFlowService.editActivity({ ...e })
                .then((res) => {
                    if (res.data.resultMsg === 'FAILURE') {
                        setDuplicateData(res.data.errorData.error);
                    } else {
                        clear();
                        setOpenSuccess(true);
                        getActivityList();
                    }
                })
                .catch((err) => {
                    if (
                        err.data.errorData.msg ===
                        'This activity name is already exist.'
                    ) {
                        let value = e.activityName;
                        setActivityName({
                            ...validateDuplicateActivityName(true),
                            value,
                        });
                    } else {
                        setOpenFail(true);
                        setMsg(t('dataFlow.FailedToUpdateData'));
                    }
                });
        }
    };

    const clear = () => {
        form.resetFields();
        setNameList([]);
        setActivityName({
            value: '',
        });
        handelClose();
    };

    const handleInputChange = (e) => {
        let value = e.target.value;
        if (value) {
            setDisableBtnDelete(true);
            const result = nameList.find((name) => name === value);
            if (result) {
                setActivityName({
                    ...validateDuplicateActivityName(true),
                    value,
                });
            } else {
                setActivityName({
                    ...validateDuplicateActivityName(false),
                    value,
                });
            }
        } else {
            setDisableBtnDelete(false);
            setActivityName({ ...validateDuplicateActivityName(false), value });
        }
    };

    const addItem = (activityName) => {
        if (activityName) {
            setDisableBtnDelete(false);
            const result = nameList.find((name) => name === activityName);
            if (result) {
                setActivityName({
                    ...validateDuplicateActivityName(true),
                    activityName,
                });
            } else {
                form.resetFields(['activityName']);
                const newActivityNameList = [...nameList];
                newActivityNameList.push(activityName);
                setNameList(newActivityNameList);
                form.setFieldsValue({
                    activityNameList: [...newActivityNameList],
                });

                let value = null;
                setActivityName({
                    ...validateAddBtnActivityName(value),
                    value,
                });
            }
        }
    };

    const removeActivity = (index) => {
        const newActivityNameList = [...nameList];
        if (duplicateData) {
            let activityName = newActivityNameList[index];
            const idxDupName = duplicateData.findIndex(
                (name) => name === activityName
            );
            if (idxDupName >= 0) {
                duplicateData.splice(idxDupName, 1);
            }
        }
        newActivityNameList.splice(index, 1);
        setNameList(newActivityNameList);
        form.setFieldsValue({
            activityNameList: [...newActivityNameList],
        });
    };

    return (
        <Modal
            className="_modal"
            footer={false}
            open={open}
            onCancel={() => {
                handelClose();
                clear();
            }}
        >
            <div>
                <div className="text-2xl font-semibold mb-6 text-center">
                    {mode === 'addActivity'
                        ? t('dataCorrelation.AddActivity')
                        : t('Edit Activity')}
                </div>

                <Form form={form} layout="vertical" onFinish={onSubmit}>
                    <Form.Item
                        name="departmentId"
                        label={t('Department')}
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Select
                            size="large"
                            disabled={true}
                            placeholder={t('Select Department')}
                        >
                            {departmentList.map((e) => {
                                return (
                                    <Select.Option key={e.id} value={e.id}>
                                        {e.value}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="businessProcessName"
                        label={t('Business Process')}
                        hidden={mode === 'addActivity' ? true : false}
                    >
                        <Input size="large" disabled={true} />
                    </Form.Item>
                    <span className="ant-col ant-form-item-label">
                        <label className="ant-form-item-required">
                            <span className="font-bold">
                                {t('Activity Name')}
                            </span>
                        </label>
                    </span>
                    <div className="pb-2 font-medium">
                        {t('Suggestions for naming')}
                    </div>
                    <div className="flex items-center space-x-2">
                        <Form.Item
                            name="activityName"
                            rules={[
                                {
                                    required:
                                        nameList?.length > 0 ? false : true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                            validateStatus={activityName.validateStatus}
                            help={activityName.errorMsg}
                            className="mb-0 w-full"
                        >
                            <Input
                                onChange={handleInputChange}
                                autoComplete="off"
                                size="large"
                                placeholder={t('Activity Name')}
                                className="w-full"
                                showCount
                                maxLength={150}
                            />
                        </Form.Item>

                        <div hidden={mode === 'addActivity' ? false : true}>
                            <Button
                                type="primary"
                                size="large"
                                prefix={<PlusOutlined />}
                                onClick={() =>
                                    addItem(
                                        form.getFieldValue(['activityName'])
                                    )
                                }
                            >
                                {t('common.Add')}
                            </Button>
                        </div>
                    </div>
                    {nameList.length > 0 && (
                        <Form.Item name="activityNameList">
                            <div className="overflow-auto max-h-[24vh] my-4">
                                {nameList.map((item, index) => (
                                    <div
                                        className="p-2 flex items-center justify-between"
                                        style={{
                                            background: '#f5f6ff',
                                            marginBlockEnd: '10px',
                                            borderRadius: '6px',
                                        }}
                                    >
                                        <span className="font-semibold text-base pl-2">
                                            {item}
                                        </span>
                                        <Button
                                            type="link"
                                            onClick={() =>
                                                removeActivity(index)
                                            }
                                            disabled={disableBtnDelete}
                                        >
                                            <svg
                                                width="15"
                                                height="15"
                                                viewBox="0 0 14 14"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M6.9998 2.18332e-08C7.54871 -7.72662e-05 8.07782 0.205044 8.48324 0.575088C8.88866 0.945132 9.1411 1.45337 9.191 2H12.5998C12.7518 2.00005 12.8982 2.0578 13.0092 2.16158C13.1203 2.26536 13.1879 2.40744 13.1982 2.5591C13.2086 2.71077 13.161 2.86071 13.0651 2.97864C12.9691 3.09656 12.832 3.17368 12.6814 3.1944L12.5998 3.2H12.1334L11.1198 11.984C11.0747 12.3739 10.8878 12.7336 10.5947 12.9947C10.3016 13.2558 9.92273 13.4001 9.5302 13.4H4.4694C4.07688 13.4001 3.69804 13.2558 3.40494 12.9947C3.11184 12.7336 2.92494 12.3739 2.8798 11.984L1.8654 3.2H1.3998C1.25481 3.19999 1.11473 3.14749 1.00546 3.05219C0.896189 2.95689 0.825123 2.82524 0.805405 2.6816L0.799805 2.6C0.799811 2.45501 0.852319 2.31493 0.947618 2.20566C1.04292 2.09638 1.17456 2.02532 1.3182 2.0056L1.3998 2H4.8086C4.85851 1.45337 5.11095 0.945132 5.51637 0.575088C5.92179 0.205044 6.4509 -7.72662e-05 6.9998 2.18332e-08ZM5.7998 5C5.6038 5 5.4398 5.124 5.4062 5.2872L5.3998 5.3504V10.2504L5.4062 10.3128C5.4398 10.476 5.6038 10.6 5.7998 10.6C5.9958 10.6 6.1598 10.476 6.1934 10.3128L6.1998 10.2496V5.3512L6.1934 5.2872C6.1598 5.1248 5.9958 5 5.7998 5ZM8.1998 5C8.0038 5 7.8398 5.124 7.8062 5.2872L7.7998 5.3504V10.2504L7.8062 10.3128C7.8398 10.476 8.0038 10.6 8.1998 10.6C8.3958 10.6 8.5598 10.476 8.5934 10.3128L8.5998 10.2496V5.3512L8.5934 5.2872C8.5598 5.1248 8.3958 5 8.1998 5ZM6.9998 1.2C6.5158 1.2 6.1118 1.544 6.0198 2H7.9798C7.887 1.544 7.4838 1.2 6.9998 1.2Z"
                                                    fill="#7B67FB"
                                                />
                                            </svg>
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </Form.Item>
                    )}

                    <div
                        className="grid grid-cols-6 mb-4"
                        hidden={!duplicateData?.length > 0}
                    >
                        <div className="col-span-5 overflow-auto max-h-[16vh] p-4 box-content">
                            <div className="text-error text-lg font-bold">
                                {t('dataFlow.ActivityNameIsExist')}
                            </div>
                            {duplicateData?.map((item) => (
                                <div className="text-error">&#8226; {item}</div>
                            ))}
                        </div>
                    </div>
                    <div className="flex justify-center items-center space-x-4 pt-12">
                        <Button
                            type="primary"
                            onClick={() => {
                                clear();
                            }}
                            size="large"
                            ghost
                        >
                            {t('common.Cancel')}
                        </Button>

                        <Button htmlType="submit" size="large" type="primary">
                            {mode === 'addActivity'
                                ? t('common.Submit')
                                : t('common.Save')}
                        </Button>
                    </div>
                </Form>
            </div>
            <ModalFail
                text={msg}
                open={openFail}
                handelClose={() => setOpenFail(false)}
            />
        </Modal>
    );
};
export default ModalActivity;
